import { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Countdown, type CountdownProps } from '@/components/Countdown';

import {
  ScCountdownWidget,
  ScCountdownWidgetCard,
  type ScCountdownWidgetProps,
} from './styled';

type CountdownWidgetProps = ScCountdownWidgetProps &
  Pick<CountdownProps, 'timeLeft'> & {
    label?: string;
    text?: string;
    withBg?: boolean;
  };

const ZERO_VALUE = '00';

export const CountdownWidget: FC<CountdownWidgetProps> = memo(
  ({ label, text, accent, showCountdown, timeLeft, withBg }) => {
    const {
      t,
      i18n: { language },
    } = useTranslation();

    if (label)
      return (
        <ScCountdownWidgetCard
          accent={accent}
          showCountdown={showCountdown}
          withBg={withBg}
        >
          <div className={`label ${language}`}>{label}</div>
          {showCountdown && (
            <div className="countdown">
              <Countdown dual timeLeft={timeLeft}>
                {({ days, hours, minutes, seconds }) => (
                  <>
                    {days !== ZERO_VALUE && (
                      <>
                        <span attr-label={t('timer.dd')}>{days}</span>:
                      </>
                    )}
                    <span attr-label={t('timer.hh')}>{hours}</span>:
                    <span attr-label={t('timer.mm')}>{minutes}</span>:
                    <span attr-label={t('timer.ss')}>{seconds}</span>
                  </>
                )}
              </Countdown>
            </div>
          )}
        </ScCountdownWidgetCard>
      );

    return (
      <ScCountdownWidget>
        <Countdown dual timeLeft={timeLeft}>
          {({ days, hours, minutes, seconds }) => (
            <div className="timer">
              <div>
                <span>
                  <span className="value">{days}</span>
                  <span>{t('timer.dd')[0]}</span>
                </span>
                <span>:</span>

                <span>
                  <span className="value">{hours}</span>
                  <span>{t('timer.hh')[0]}</span>
                </span>
                <span>:</span>

                <span>
                  <span className="value">{minutes}</span>
                  <span>{t('timer.mm')[0]}</span>
                </span>
                <span>:</span>

                <span>
                  <span className="value">{seconds}</span>
                  <span>{t('timer.ss')[0]}</span>
                </span>
              </div>
              {text && <div className="text">{text}</div>}
            </div>
          )}
        </Countdown>
      </ScCountdownWidget>
    );
  }
);
